import { connect } from "react-redux";
import ClientProfileIndex from "../../components/Clients/EditClientProfile/ClientProfile";
import {
  getClientProfile,
  getIndustryOptions,
  getTierOptions,
  getAccountManage,
  updateClientProfile,
  rollbackProfileStatus,
  suspendAndReactivate,
  getTeamMember,
  configInsightsStandard,
  getConfigInsightsStandard,
  resetStandardConfig,
} from "../../actions/Clients";

import {
  getTimezone,
  getStates,
  getCompanyLogo,
  updateLogo,
  setStatus,
} from "../../actions/Profile";

const mapStateToProps = state => {
  const {
    edit_client_profile,
    industryOptions,
    tier_options,
    ifEditClientProfileSuccess,
    ifCreateClientProfileSuccessBasic,
    teamMember_options,
    insights_standard_config,
    clientProfileUpdateError,
  } = state.clients;
  const { roleName, token, loginUserDetail } = state.app;
  const { account_manager } = state.employees;

  const {
    timezone,
    allstates,
    ifUpdateSuccess,
    company_logo,
  } = state.myProfile;
  return {
    edit_client_profile,
    timezone,
    industryOptions,
    tier_options,
    account_manager,
    roleName,
    ifEditClientProfileSuccess,
    allstates,
    ifUpdateSuccess,
    token,
    company_logo,
    teamMember_options,
    loginUserDetail,
    insights_standard_config,
    ifCreateClientProfileSuccessBasic,
    clientProfileUpdateError,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getClientProfile: id => {
      dispatch(getClientProfile(id));
    },
    getTimezone: () => {
      dispatch(getTimezone());
    },
    getIndustryOptions: () => {
      dispatch(getIndustryOptions());
    },
    getTierOptions: () => {
      dispatch(getTierOptions());
    },
    getAccountManage: () => {
      dispatch(getAccountManage());
    },
    updateClientProfile: (id, obj) => {
      dispatch(updateClientProfile(id, obj));
    },
    rollbackProfileStatus: () => {
      dispatch(rollbackProfileStatus());
    },
    suspendAndReactivate: (clientId, status) => {
      dispatch(suspendAndReactivate(clientId, status));
    },
    getStates: () => {
      dispatch(getStates());
    },
    getTeamMember: id => {
      dispatch(getTeamMember(id));
    },
    getCompanyLogo: id => {
      dispatch(getCompanyLogo(id));
    },
    updateLogo: (id, uuid) => {
      dispatch(updateLogo(id, uuid));
    },
    setStatus: value => {
      dispatch(setStatus(value));
    },
    configInsightsStandard: (id, obj) => {
      dispatch(configInsightsStandard(id, obj));
    },
    getConfigInsightsStandard: id => {
      dispatch(getConfigInsightsStandard(id));
    },
    resetStandardConfig: () => {
      dispatch(resetStandardConfig());
    },
  };
};

const ClientProfile = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClientProfileIndex);

export default ClientProfile;



// WEBPACK FOOTER //
// ./src/containers/Clients/editClientProfile.js